import { inject } from '@angular/core';
import { Route, Router } from '@angular/router';
import { AuthService } from './auth/components/login/services/auth.service';
import { LayoutComponent } from './shared/components/layout/layout.component';
import { SplashComponent } from './shared/components/layout/splash/splash.component';
import { AuthGuard } from './shared/guards/access.guard';
import { AuthReverseGuard } from './shared/guards/reverseAccess.guard';

export const appRoutes: Route[] = [
  {
    path: '',
    component: SplashComponent,
    title: 'Login',
    loadChildren: () =>
      import('src/app/auth/auth.routes').then(m => m.loginRoutes),
    canActivate: [AuthReverseGuard],
  },
  {
    path: 'dashboard',
    component: LayoutComponent,
    loadChildren: () =>
      import('src/app/features/dashboard.routes').then(m => m.dashboardRoutes),
    canActivate: [AuthGuard],
  },
  {
    path: 'contact-us',
    title: 'Contact Us',
    loadComponent: () =>
      import('src/app/features/contact-us/contact-us.component').then(
        m => m.ContactUsComponent
      ),
    //canActivate: [AuthReverseGuard],
  },
  {
    path: '**',
    loadComponent: () =>
      import('src/app/shared/components/not-found/not-found.component').then(
        m => m.NotFoundComponent
      ),
  },
];
